export enum ERoutes {
  MAIN = '/',
  SYSTEMS = '/systems',
  SYSTEM_DETAILS = '/systems/:id',
  SYSTEM_COMPARE = '/systems/:id/compare',
  SYSTEM_PLAN_EDIT = '/systems/:id/plan',
  TESTS = '/tests',
  USERS = '/users',
  LICENSE = '/license',
  AUTHORIZATION = '/auth',
  AUTH_RECOVERY = '/auth-recovery',
  NEW_PASSWORD = '/new-password',
  PROFILE = '/profile',
  ACCEPT_INVITE = '/accept-invite',
}
